define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/modules",
	"csi/main",
	"csi/config",
	"csi/def",
	"csi/def/Action",
	"csi/def/Relationship",
	"csi/def/ViewRef",
	"csi/enums",
	"csi/form/Widget",
	"csi/state/rootStore",
	"csi/store/_base",
	"csi/store/Names",
	"csi/xml",
	"csi/xml/Query",
	"./main",
], function(declare,lang,modules,csi,config,def,Action,Relationship,ViewRef,enums,Widget,{featureTogglesStore},csiStore,Names,xml,Query,Sourcing) {
	const INSPIRATION_STYLE_TYPE_ID = "InspirationStyleType";

	return declare(Widget, {
		TEMPLATE_DP: "SRTDPTemplate",
		SUPPLIERS: "SRTSuppliers",
		SUPPLIER_FACTORIES: "SRTSupplierFactories",
		FOOD : "Food",
		FOOD_SKU : "FoodSKU",
		FORMULATED_MATERIAL : "FormulatedMaterial",
		MATERIAL : "Material",
		STYLE : "Style",
		QUOTE_CREATE_OPTION: "QuoteCreateOption",
		REQUEST_TYPE : "RequestType",
		SAMPLE_CREATE_OPTION: "SampleCreateOption",
		SAMPLE_TYPE : "SampleType",
		SRT_QUOTES: "SRTQuotes",
		SUBMIT_QUOTES_TO_WF: "SubmitQuotesToWF",
		SR_SUBTYPE: "SRSubtype",

		// ignore default save & new behavior
		bDefaultSaveAndNew: false,

		_requestTypeIsFP: function() {
			const requestType = xml.enumGetText(this.getFieldValue(this.REQUEST_TYPE));
			return requestType === this.FOOD ||
			   requestType === this.FOOD_SKU ||
			   requestType === this.FORMULATED_MATERIAL;
		},

		getFieldStore: function(/*csi.def.Field*/field, /*String*/value) {
			if (field.m_id == this.SRT_QUOTES) {
				const rel = lang.mixin(new Relationship(), {
					m_id: this._requestTypeIsFP() ? "FoodSupplierItemTemplates" : "Templates",
					m_url: "centric://REFLECTION/INSTANCE/SiteLibSupplierItem/SiteLibSupplierItem"
				});

				const storeOptions = csiStore.namesOptionsByRelationship(this.getContext(), rel);
				storeOptions.action = lang.mixin(new Action(),{
					m_viewRef: lang.mixin(new ViewRef(), {
						m_id: this._requestTypeIsFP() ? "FoodSupplierItemTemplates" : "SupplierItemTemplates",
						m_url: "centric://REFLECTION/INSTANCE/SiteLibSupplierItem/SiteLibSupplierItem"
					}),
				});

				const srtQuotesStore = new Names(storeOptions);
				return srtQuotesStore;
			}

			if (field.m_id == this.TEMPLATE_DP) {
				const subtypeFieldValue = this.getFieldValue(this.SR_SUBTYPE);
				const dptQuery = new Query().Attr("Active", "EQ", true).Attr("TemplateType", "EQ", this.getFieldValue("RequestType"));
				if (Sourcing.filterDPTFalseSupplierSpecific(subtypeFieldValue) && subtypeFieldValue !== csi.EMPTY_URL) {
					dptQuery.Attr("IsSupplierSpecific", "EQ", false);
				} else if(Sourcing.filterDPTTrueSupplierSpecific(subtypeFieldValue) && subtypeFieldValue !== csi.EMPTY_URL) {
					dptQuery.Attr("IsSupplierSpecific", "EQ", true);
				}
				const rel = lang.mixin(new Relationship(), {
					m_typeNode: "DataPackageTemplate",
					m_query: dptQuery
				});

				const storeOptions = csiStore.namesOptionsByRelationship(this.getContext(), rel);
				storeOptions.action = lang.mixin(new Action(),{
					m_viewRef: lang.mixin(new ViewRef(), {
						m_id: "DataPackageTemplates",
						m_url: "centric://APPAREL/SizeChartAdmin"
					}),
					m_fixedQuery: dptQuery
				});

				const srdpStore = new Names(storeOptions);
				srdpStore.put(csiStore.nameObject(""));
				return srdpStore;
			}

			return this.inherited(arguments);
		},

		/**
		 * Multiple fields should be hidden if request type is Food or Formulated Material (C8-39079)
		 * @param {View} defView
		 * @param {Field} field
		 * @param {String} value
		 */
		onChangeRequestType: function(defView, field, value) {
			if (this.isNew()) {
				this.resetFieldStoreAndValue(this.SR_SUBTYPE, csi.EMPTY_URL);
				this.setFieldDisabled(this.getField(this.SR_SUBTYPE), xml.enumGetText(value) == "");
			}
			this.setFieldHidden(this.getField(this.QUOTE_CREATE_OPTION), this._requestTypeIsFP());
			this.setFieldHidden(this.getField(this.SAMPLE_CREATE_OPTION), this._requestTypeIsFP());
			this.setFieldHidden(this.getField(this.SUBMIT_QUOTES_TO_WF), this._requestTypeIsFP());
		},

		onChangeSampleType: function(defView, field, value) {
			this.setFieldDisabled("SampleCreateOption", xml.enumGetText(value) == ""); // disabled if no (Material) SampleType
			this.setFieldDisabled("SampleQuantity",	 xml.enumGetText(value) == ""); // disabled if no (Material) SampleType
		},

		onChangeQuotes: function(defView, field, value) {
			this.setFieldDisabled("QuoteCreateOption", value.length == 0); // disabled if no quote templates
			this.setFieldDisabled("SubmitQuotesToWF",  value.length == 0); // disabled if no quote templates
		},

		_resolveView: function() {
			// summary: remove specification field(s) if not installed; set default value for SubmitQuotesToWF
			if (!modules.hasModule("Specification")) {
				this.defView.removeField(this.TEMPLATE_DP);
			}
			if (config.getClassSetting("SupplierItem", "WorkflowName")) {
				this.addDefaultValue("SubmitQuotesToWF", true);
			} else {
				this.addFixedValue("SubmitQuotesToWF", false);
			}

			this.inherited(arguments);

			this.insertFieldIfNotExist(this.SR_SUBTYPE, 2, {
				m_bRequired: true,
				m_onChange: "onChangeSRSubtype",
			});
			this.insertFieldIfNotExist(this.SUPPLIER_FACTORIES, 3, {
				m_typeControl: def.FIELD_MULTI_SELECT,
			});

			let copyOrEdit = this.isCopy() || this.isEdit();
			this.setFieldDisabled(this.REQUEST_TYPE, copyOrEdit);
			this.setFieldDisabled(this.SR_SUBTYPE, copyOrEdit);

			var f = this.getField(this.REQUEST_TYPE);

			if (f) {
				f.m_onChange = "onChangeRequestType";
			}

			f = this.getField("SampleType");

			if (f) {
				f.m_onChange = "onChangeSampleType";
			}

			f = this.getField("SRTQuotes");

			if (f) {
				f.m_onChange = "onChangeQuotes";
			}
		},

		_buildFields: function(/*Field[]*/fields) {
			this.inherited(arguments);

			this.getField(this.SRT_QUOTES).m_dependency = this.REQUEST_TYPE;
			this.handleFactoryDirectDevelopment();
			// initial values
			this.onChangeSampleType(null, null, this.getFieldValue("SampleType"));
			this.onChangeQuotes(null, null, this.getFieldValue("SRTQuotes"));
			this.onChangeRequestType(null, null, this.getFieldValue(this.REQUEST_TYPE));
		},

		/**
		 * @override
		 * hide the InspirationStyleType field conditionally
		 */
		_updateFieldVisibility (field) {
			this.inherited(arguments);

			// take care of the edit case
			if (!field) {
				const template = this.getFormData().getSource().getNode();
				if (template) {
					this._processInspirationStyleType(template[this.REQUEST_TYPE], template[this.SR_SUBTYPE]);
				}

				return;
			}

			const fieldId = field.getControlName();
			if (fieldId ===this.SR_SUBTYPE || fieldId===this.REQUEST_TYPE) {
				this._processInspirationStyleType();
			}
		},

		/** hide the InspirationStyleType conditionally  */
		_processInspirationStyleType(existingRequestType, existingSubtypeUrl) {
			const { REQUEST_TYPE, SR_SUBTYPE,  STYLE } = this;
			const requestType = xml.enumGetText(existingRequestType || this.getFieldValue(REQUEST_TYPE));
			const subtypeUrl =  existingSubtypeUrl || this.getFieldValue(SR_SUBTYPE);
			const isFDD = xml.isValidURL(subtypeUrl) && !Sourcing.isSubtypeSupplierSourced(subtypeUrl);

			// "InspirationStyleType" field should be visible only on Style SR Template (C8-7112)
			// InspirationStyleType should be hidden for FDD type
			const hideField = requestType !== STYLE || isFDD;

			this.setFieldHidden(INSPIRATION_STYLE_TYPE_ID, hideField);
		},

		/**
		 * Show/Hide Supplier and Supplier Factory fields based on feature toggle
		 */
		handleFactoryDirectDevelopment() {
			this.setFieldHidden(this.SUPPLIERS, true);
			this.setFieldHidden(this.SUPPLIER_FACTORIES, true);
			this.onChangeSRSubtype(null, null, this.getFieldValue(this.SR_SUBTYPE));
		},

		/**
		 * Show/Hide Supplier and Supplier Factory fields based on SR Subtype
		 * @param {View} defView
		 * @param {Field} field
		 * @param {String} value
		 */
		onChangeSRSubtype(defView, field, value) {
			subtypeFieldValue = this.getFieldValue(this.SR_SUBTYPE);
			
			const newTypeControl = Sourcing.filterDPTTrueSupplierSpecific(subtypeFieldValue) ? def.FIELD_FILTERING_SELECT : def.FIELD_MULTI_SELECT;
			if(!xml.isValidURL(value)) {
				this.setFieldHidden(this.SUPPLIERS, true);
			} else if (Sourcing.isSubtypeAllocated(value)) {
				this.setFieldHidden(this.SUPPLIER_FACTORIES, true);
				this.setFieldHidden(this.SUPPLIERS, true);
				this.setFieldDisabled(this.SUPPLIER_FACTORIES, true);
				this.setFieldDisabled(this.SUPPLIERS, true);
			} else if(Sourcing.isSubtypeSupplierSourced(value)) {
				const newType = Sourcing.filterDPTTrueSupplierSpecific(subtypeFieldValue) ? xml.ATTR_REF : xml.ATTR_REFLIST;
				const suppliersField = this.defView.getField(this.SUPPLIERS);
				suppliersField.m_typeControl = newTypeControl;
				suppliersField.m_type = newType;
				this._rebuildField(suppliersField);
				this.setFieldHidden(this.SUPPLIER_FACTORIES, true);
				this.setFieldHidden(this.SUPPLIERS, false);
			} else {
				const newTypeFDD = Sourcing.filterDPTTrueSupplierSpecific(subtypeFieldValue) ? xml.ATTR_REF : xml.ATTR_REFSET;
				const suppliersFactoryField = this.defView.getField(this.SUPPLIER_FACTORIES);
				suppliersFactoryField.m_typeControl = newTypeControl;
				suppliersFactoryField.m_type = newTypeFDD;
				this._rebuildField(suppliersFactoryField);
				this.setFieldHidden(this.SUPPLIERS, true);
				this.setFieldHidden(this.SUPPLIER_FACTORIES, false);
			}
			if (this.isNew()) {
				this.resetFieldStoreAndValue(this.TEMPLATE_DP, csi.EMPTY_URL);
				this.setFieldValue(this.SUPPLIERS, []);
				this.setFieldValue(this.SUPPLIER_FACTORIES, []);
			}
		},
	});
});
